module.exports = __webpack_public_path__ + "media/packs/images/flags/KH-0fc9ca4958eae165929ae1b90acdb69e.svg";